<template>
    <router-view
    ></router-view>
</template>

<script>
export default {
name: "WebinarsBase",
    methods:{
    }
}
</script>

<style scoped>

</style>